module.exports = __webpack_public_path__ + "img/Feature.521f8f0f.png";